import template from './rz-technik-feld.html.twig';
import './rz-technik-feld.scss';

const { Component } = Shopware;

/**
 * Technikdaten als Zeilen statt als JSON.
 *
 * Gespeichert wird weiterhin dieselbe Liste wie bisher:
 *   [{ key: 'akku', label: 'Akku', value: '1.500 mAh' }, …]
 *
 * key ist der technische Schlüssel (das Theme setzt darüber ein Symbol),
 * label die Überschrift, value die Angabe. Wer keinen Schlüssel vergibt,
 * bekommt einen aus der Bezeichnung – damit muss sich das Katalogteam
 * nicht mit Schlüsseln befassen.
 */
const BEKANNT = [
    { key: 'typ', label: 'Bauart' },
    { key: 'akku', label: 'Akku' },
    { key: 'leistung', label: 'Leistung' },
    { key: 'tank', label: 'Tankinhalt' },
    { key: 'widerstand', label: 'Widerstand' },
    { key: 'anschluss', label: 'Anschluss' },
    { key: 'laden', label: 'Laden' },
    { key: 'masse', label: 'Maße' },
];

Component.register('rz-technik-feld', {
    template,

    props: {
        value: { type: Array, required: false, default: null },
        disabled: { type: Boolean, required: false, default: false },
    },

    data() {
        return { bekannt: BEKANNT };
    },

    computed: {
        zeilen() {
            return Array.isArray(this.value)
                ? this.value.filter((z) => z && typeof z === 'object').map((z) => ({
                    key: String(z.key ?? ''),
                    label: String(z.label ?? ''),
                    value: String(z.value ?? ''),
                }))
                : [];
        },
    },

    methods: {
        schluesselAus(bezeichnung) {
            const treffer = BEKANNT.find((b) => b.label.toLowerCase() === bezeichnung.trim().toLowerCase());
            if (treffer) return treffer.key;

            return bezeichnung.toLowerCase()
                .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
                .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        },

        aendere(index, feld, wert) {
            const zeilen = this.zeilen.map((z) => ({ ...z }));
            zeilen[index][feld] = wert;

            if (feld === 'label' && !zeilen[index].key) {
                zeilen[index].key = this.schluesselAus(wert);
            }

            this.melde(zeilen);
        },

        hinzu(vorlage) {
            const zeilen = this.zeilen.map((z) => ({ ...z }));
            zeilen.push(vorlage ? { ...vorlage, value: '' } : { key: '', label: '', value: '' });
            this.melde(zeilen);
        },

        entferne(index) {
            const zeilen = this.zeilen.map((z) => ({ ...z }));
            zeilen.splice(index, 1);
            this.melde(zeilen);
        },

        melde(zeilen) {
            // Leere Zeilen gar nicht erst speichern.
            const sauber = zeilen.filter((z) => z.label.trim() !== '' || z.value.trim() !== '');
            this.$emit('update:value', sauber.length ? sauber : null);
        },

        nochNichtVergeben(b) {
            return !this.zeilen.some((z) => z.key === b.key);
        },
    },
});
